import React, { PureComponent } from "react"

/* Constants */
import { utils, env } from "../../constants"


/* Component Double */
class Double extends PureComponent {

    render = () => {

        const { onClick } = this.props

        return (
            <div onClick={() => onClick()} className="game-button double-button">
                <img src={`${env.endpoint}/images/buttons/double.png`} alt="double" />
                <p>{utils.translate("DOUBLE")}</p>
            </div>
        )
    }

}

export default Double